import { useContext } from 'react'
import * as KeyNames from '../api/KeyNames';
import { ROLES } from '../config/permissions-map'
//import { PERMISSIONS } from "./../config/permissions-map";
import { SessionContext } from '../Components/Context/SessionContext';

export function GetPermissionForTitle(itemAsideMenu) {
    let permission = false;
    //const permissions = PERMISSIONS[useGetRole()];
    const permissions = useGetUser().role.permissions.map(e => e.id);
    itemAsideMenu.routes.forEach(route => {
        if (route.subRoutes) {
            route.subRoutes.forEach(subRoute => {
                subRoute.scopes.forEach(scope => {
                    if (permissions.some((permissioX) => permissioX == scope)) permission = true;
                });
            });
        }
        else {
            route.scopes.forEach(scope => {
                if (permissions.some((permissioX) => permissioX == scope)) permission = true;
            });
        }
    });
    return permission;
}

export function GetPermissionForRoute(route) {
    let permission = false;
    //const permissions = PERMISSIONS[useGetRole()];
    const permissions = useGetUser().role.permissions.map(e => e.id);

    if (route.subRoutes) {
        route.subRoutes.forEach(subRoute => {
            subRoute.scopes.forEach(scope => {
                if (permissions.some((permissioX) => permissioX == scope)) permission = true;
            });
        });
    }
    return permission;
}



export function usePermission({ scopes }) {
    let permission;
    //const permissions = PERMISSIONS[useGetRole()];
    const permissions = useGetUser().role.permissions.map(e => e.id);
    if (scopes.length === 0) {
        permission = true;
    } else {
        const scopesMap = {};
        scopes.forEach((scope) => {
            scopesMap[scope] = true;
        });
        permission = permissions.some((permission) => scopesMap[permission]);
    }
    return permission;
}

export function useGetRole() {
    return useGetUser().role.name;
}
export function getRoleName() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useGetUser().role.name;

    /*
    switch (role) {
        case ROLES.coordinacionGeneral: return ROLE_NAMES.coordinacionGeneral
        case ROLES.comercial: return ROLE_NAMES.comercial
        case ROLES.comercialMatriz: return ROLE_NAMES.comercialMatriz
        case ROLES.cordinadores: return ROLE_NAMES.cordinadores
        case ROLES.administracion_finanzas: return ROLE_NAMES.administracion_finanzas
        case ROLES.gerenciaOperaciones: return ROLE_NAMES.gerenciaOperaciones
        case ROLES.gerenciaGeneral: return ROLE_NAMES.gerenciaGeneral
        case ROLES.pruebas: return ROLE_NAMES.pruebas
        case ROLES.adminLocatario: return ROLE_NAMES.adminLocatario
        case ROLES.operadorLocatario: return ROLE_NAMES.operadorLocatario
        default: return
    }
    */

}

export function useGetUser() {
    const { session } = useContext(SessionContext);
    return session;
}

export function useGetToken() {
    return localStorage.getItem(KeyNames.SessionData) ? localStorage.getItem(KeyNames.SessionData) : sessionStorage.getItem(KeyNames.SessionData);
}
/**
 * 
 * @returns Array of roles current role can view
 */
export const useGetRoleList = () => {
    //despues del login, crear rolelist, guardar en custom hook



    switch (useGetRole()) {
        case ROLES.coordinacionGeneral:
            return [
                ROLES.coordinacionGeneral,
                ROLES.comercial,
                ROLES.comercialMatriz,
                ROLES.cordinadores,
                ROLES.administracion_finanzas,
                ROLES.gerenciaOperaciones,
                ROLES.gerenciaGeneral,
                ROLES.pruebas,
                ROLES.adminLocatario,
                ROLES.operadorLocatario,
            ].join(",");
        case ROLES.gerenciaOperaciones:
            return [
                ROLES.coordinacionGeneral,
                ROLES.comercial,
                ROLES.comercialMatriz,
                ROLES.cordinadores,
                ROLES.administracion_finanzas,
                ROLES.gerenciaOperaciones,
                ROLES.gerenciaGeneral,
                ROLES.pruebas,
                ROLES.adminLocatario,
                ROLES.operadorLocatario,
            ].join(",");
        default:
            return ''
    }
}



